import { State } from "../types";

export interface SetActiveJobAction {
  type: "SET ACTIVE JOB";
  id: string;
}
export const setActiveJob = (state: State, action : SetActiveJobAction): State => {
  return {
    ...state,
    activeJobId:action.id
  };
}
